/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
export type applicationActionItemFragment = { readonly __typename: 'ApplicationActionItem', readonly id: string, readonly action: string, readonly completedAt: any | null, readonly insertedAt: any, readonly sourceId: string | null, readonly sourceType: string | null };

export const applicationActionItemFragment = gql`
    fragment applicationActionItemFragment on ApplicationActionItem {
  id
  action
  completedAt
  insertedAt
  sourceId
  sourceType
}
    `;